<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="700px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon
          color="primary"
          title="Edit"
        >
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      :loading="loading"
      color="primary"
      style="margin-bottom:0"
    >
      <template v-slot:header>
        <v-card-title>
          <div class="px-2">
            <h4 class="title font-weight-light">
              Payment Channel
            </h4>
            <p class="category font-weight-thin">
              Edit Payment Channel
            </p>
          </div>
          <v-spacer />
          <v-btn  
            text
            icon 
            color="white"
            @click="dialog = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
      </template>
      <v-form
        v-if="dialog && !loading"
      >
        <v-container
          class="overflow"
          data-simplebar
        >
          <v-row>
            <v-col class="title">
              {{ localPaymentChannel.company.name }}
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-autocomplete
                v-model="localPaymentChannel.payment_channel_type.id"
                v-validate="'required'"
                item-text="name"
                item-value="id"
                :items="paymentChannelTypes"
                label="Type"
                :error-messages="errors.collect('type')"
                data-vv-name="type"
                data-vv-as="Payment Channel Type"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-autocomplete
                v-model="localPaymentChannel.bank.id"
                v-validate="'required'"
                item-text="name"
                item-value="id"
                :items="banks"
                label="Bank"
                :error-messages="errors.collect('bank')"
                data-vv-name="bank"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-data-table
                v-model="localSelectedBranch"
                dense
                :headers="headers"
                :items="branches"
                hide-default-footer
                fixed-header
                disable-pagination
                item-key="branch_uid"
                item-value="branch_uid"
                show-select
                sort-by="branch_name"
                class="elevation-1 mb-3"
                :search="search"
                height="335px"
              >
                <template v-slot:top>
                  <v-toolbar
                    flat
                  >
                    <v-row>
                      <v-col class="col">
                        <v-toolbar-title>
                          Select at least one Branch:
                        </v-toolbar-title>
                      </v-col>
                      <v-col class="col">
                        <v-text-field
                          v-model="search"
                          label="Search"
                          append-icon="search"
                        />
                      </v-col>
                    </v-row>
                  </v-toolbar>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="localPaymentChannel.reference"
                v-validate="'required'"
                label="Reference"
                :error-messages="errors.collect('reference')"
                data-vv-name="reference"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <span>Active Payment Channel?</span>
              <v-radio-group
                v-model="localPaymentChannel.is_active"
                row
              >
                <v-radio
                  label="Yes"
                  :value="1"
                />
                <v-radio
                  label="No"
                  :value="0"
                />
              </v-radio-group>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer />
            <v-btn
              :loading="progressing"
              color="success"
              @click="submitForm"
            >
              Edit
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-form>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      paymentChannelId: String,
    },

    data () {
      return {
        dialog: false,
        loading: false,
        progressing: false,

        localPaymentChannel: '',
        headers: [
          { text: 'Branch', value: 'branch_name', align: 'left' },
        ],
        localSelectedBranch: [],
        selectedBranch: [],
        branches: [],
        companies: [],
        paymentChannelTypes: [],
        banks: [],
        
        search: '',
      }
    },
    watch: {
      dialog (value) {
        if (!value) {
          this.$validator.pause()
          this.$resetData()
        } else {
          this.loadData()
          this.$validator.resume()
        }
      },
    },
    methods: {
      loadData () {
        this.loading = true
        Promise.all([
          this.$api.companies().list(),
          this.$api.banks().list(),
          this.$api.paymentChannelTypes().list(),
          this.$api.paymentChannels().show(this.paymentChannelId),
          this.$api.branches().list(),
        ])
          .then(([companies, banks, paymentChannelTypes, paymentChannel, branches]) => {
            this.companies = companies.data
            this.banks = banks.data
            this.paymentChannelTypes = paymentChannelTypes.data
            this.localPaymentChannel = { ...paymentChannel.data[0] }
            if (!this.localPaymentChannel.bank) { // assign an empty object if bank is null
              this.localPaymentChannel.bank = {
                bankCode: null,
                bankId: null,
                code: null,
                created_at: null,
                id: null,
                name: null,
                updated_at: null,
              }
            }
            this.branches = branches.data
            this.localPaymentChannel.branch_payment_channels.map((branchPaymentChannel) => {
              this.branches.filter((branch) => {
                if (branch.branch_uid === branchPaymentChannel.branch_uid) return this.selectedBranch.push(branch)
              })
            })
            this.localSelectedBranch = _.clone(this.selectedBranch)
            this.loading = false
          })
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.paymentChannels().update(this.localPaymentChannel.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ color: 'success', message: 'Payment Channel Successfully updated' })

                  this.dialog = false
                }
              }).catch(err => {
                console.log(err)
                this.$snack({ color: 'error', message: err.response.statusText })
              }).then(() => {
                this.dialog = false
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        const branches = []
        this.localSelectedBranch.map((selectedBranch) => {
          branches.push(selectedBranch.branch_uid)
        })
        return {
          type_id: this.localPaymentChannel.payment_channel_type.id,
          bank_id: this.localPaymentChannel.bank.id,
          reference: this.localPaymentChannel.reference,
          is_active: this.localPaymentChannel.is_active,
          branches: branches,
        }
      },
    },
  }
</script>
<style>
  .overflow {
    height: 60vh;
    overflow-x: hidden;
  }

  .simplebar-track.simplebar-vertical .simplebar-scrollbar:before {
    background-image: linear-gradient( grey , grey);
  }
</style>
